import { graphql } from 'src/graphql';

export const InviteToTeam = graphql(`
  mutation inviteToJoinTeam($_id: ID!, $email: String!, $name: String) {
    inviteToJoinTeam(_id: $_id, email: $email, name: $name) {
      _id
    }
  }
`);
